/* Create Minicart */
/* -------------------------------------------------------------------------------------- */
function addMiniCart() {
	$.getJSON('/cart.js').then(
		function(cart) {
			$('.c-cart-pop-mini').addClass('active');
			$('.js-cart-items').empty();
			if(cart.item_count > 0){
				$('.js-cart-empty').removeClass('active');
				$('.js-cart-items').addClass('active');
				$('.js-cart-min-count-cart').addClass('active');
				$('.js-cart-min-view-header').addClass('active');
				$('.js-cart-min-free').addClass('active');
				let iNote = cart.note;
				for(let i = 0; i < cart.items.length; i++){
					let iName = cart.items[i].product_title;
					let iId = cart.items[i].variant_id;
					let iVariant = cart.items[i].variant_title;
					let ikey = cart.items[i].key;
					let iImg = cart.items[i].image;
					let iQuantity = cart.items[i].quantity;
					let iUrl = cart.items[i].url;
					let iPrice = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cart.items[i].line_price/100);
					let iTotal = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cart.items_subtotal_price/100);
					let iOptions = cart.items[i].options_with_values;
					let iOptionsHTML = ' ';				  
					for(let i = 0; i < iOptions.length; i++){
						var iOptionsLabel = iOptions[i].name == 'Size' ? 'Talla' : iOptions[i].name;
						let iOption = '<div class="c-cart-pop-mini__data-variant mb-p20">' +
										'<span>' + iOptionsLabel + ': </span>'+ iOptions[i].value +
										'</div>';
						iOptionsHTML = iOptionsHTML + iOption;
					}
					let iPriceHTML;
					iPriceHTML = '<div class="c-cart-pop-mini__data-price">' +
									iPrice +
								'</div>';
					let tmpl;
					tmpl = '<div class="c-cart-pop-mini__list-item js-cart-min-item" data-product-id="'+ iId +'" data-product-line="' + (i+1) + '" data-product-quantity="' + iQuantity + '">' +
								'<div class="row">' +
									'<div class="col-6">' + 
										'<a href="' + iUrl + '"><div class="c-cart-pop-mini__image" style="background: url(' + iImg + ') center center no-repeat; background-size: contain;"></div></a>' +
									'</div>' +
									'<div class="col-6">' +
										'<div class="c-cart-pop-mini__details">' +
											'<a class="link link--not-decoration mb-p10" href="' + iUrl + '"><p class="c-cart-pop-mini__data-title mb-p0">' + iName + '</p></a>' +
											iPriceHTML +
											iOptionsHTML +
										'</div>' +
										'<a class="c-cart-pop-mini__close-item js-cart-min-remove" data-product-line="'+ (i+1) +'" title="close">' + 
											'Eliminar producto' +
										'</a>' +
									'</div>' +
									'<div class="col-12 d-none">' +
										'<div class="c-quantity__wrapper mt-p15">' +
											'<quantity-input class="c-quantity js-add-minicart-quantity">' +
												'<button class="c-quantity__button no-js-hidden" name="minus" type="button">' +
													'<span class="d-none"></span>' +
                									'<span class="c-quantity__button-minus"></span>' +
												'</button>' +
												'<input class="c-quantity__input js-quantity-input" type="number" name="updates[]" value="' + iQuantity + '" min="0" id="Quantity-1" data-index="1">' +
												'<button class="c-quantity__button no-js-hidden" name="plus" type="button">' +
													'<span class="d-none"></span>' +
               										'<span class="c-quantity__button-plus"></span>' +
												'</button>' +
											'</quantity-input>' +
										'</div>' +
									'</div>' +
								'</div>' +
								'</div>';
					$(tmpl).appendTo('.js-cart-items');
					$('.js-cart-total').text(iTotal);
					$('.js-cart-min-view-cart').text(cart.item_count);
					$('[data-cart-notes]').val(iNote);
					if (cart.item_count <= 1) {
						$('.js-cart-min-view-cart').text(cart.item_count + ' Artículo');
					}else if (cart.item_count > 1) {
						$('.js-cart-min-view-cart').text(cart.item_count + ' Artículos');
					}
				}
				var minimum = $('.js-cart-min-free').attr('data-product-free-delivery');
				var minimum = $('.js-cart-min-free').attr('data-product-free-delivery');
				var minimum_money = parseFloat(minimum) * 100;
				if (cart.items_subtotal_price < minimum_money) {
					var minimum_purchase = minimum_money - parseFloat(cart.items_subtotal_price);
					$('[data-product-free-total]').empty().append(new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(minimum_purchase/100));
					$('.js-cart-min-free').addClass('active');
				}else {
					$('.js-cart-min-free').removeClass('active');
				}
			}else {
				let iTotal = cart.items_subtotal_price;
				$('.js-cart-total').text(iTotal);
				$('.js-cart-empty').addClass('active');
				$('.js-cart-items').removeClass('active');
				$('.js-cart-min-count-cart').removeClass('active');
				$('.js-cart-min-view-header').removeClass('active');
				$('.js-cart-min-free').removeClass('active');
				if (cart.item_count <= 1) {
					$('.js-cart-min-view-cart').text(cart.item_count + ' Artículo');
				}else if (cart.item_count > 1) {
					$('.js-cart-min-view-cart').text(cart.item_count + ' Artículos');
				}
			}
			$('[data-cart-count-bubble]').removeClass('d-none');
			$('[data-cart-count]').text(cart.item_count);
			$('[data-cart-count-bubble-total]').text(cart.items_subtotal_price);
		}.bind(this)
	);
}
/* Update Minicart */
/* -------------------------------------------------------------------------------------- */
function updateMiniCart(iQuantity, line_item) {
	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		data: {
			quantity: iQuantity,
			line: line_item
		},
		dataType: 'json',           
		success: function() {
			addMiniCart();
		},
		complete: function() {
		},
		error: function() {
		}
	});
}
/* Update Nota of Minicart */
/* -------------------------------------------------------------------------------------- */
function updateNoteMiniCart(iNote) {
	$.ajax({
		type: 'POST',
		url: '/cart/update.js',
		data: {
			note: iNote
		},
		dataType: 'json',           
		success: function() {
			addMiniCart();
		},
		error: function() {
		}
	});
}
document.addEventListener('DOMContentLoaded', () => {
	/* Add to cart - Minicart */
	/* -------------------------------------------------------------------------------------- */
	$('body').on('click', '.js-add-cart', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var el = $(this);
		var product_id = parseFloat(el.attr("data-product-variant-id"));
		var product_quantity = parseFloat(el.attr("data-product-quantity"));
		el.find('[data-add-to-cart-text]').addClass('d-none');
		el.find('[data-loader]').removeClass('d-none');
		// Jibbitz
		var conjunto = '41433686245555';
		var parent = 'child';
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: {
				quantity: product_quantity,
				id: product_id
			},
			dataType: 'json',
			success: function(){
				// Turn on Minicart
				addMiniCart();
				el.find('[data-add-to-cart-text]').removeClass('d-none');
				el.find('[data-loader]').addClass('d-none');
				// Product loading message on PRODUCT CARD
				el.closest('.js-item-products').find('[js-card-product-message]').removeClass('active');
				el.closest('.js-item-products').find('[text-message-warning]').empty();
				// Product loading message on QUICK VIEW
				if (el.hasClass('js-close-quickview')) {
					$('[js-quick-view-product]').removeClass('active');
					el.closest('[js-quick-view-product]').find('[js-quickview-message]').removeClass('active');
					el.closest('[js-quick-view-product]').find('[text-message-warning]').empty();
				}
			},
			error: function(response) {
				el.find('[data-add-to-cart-text]').removeClass('d-none');
				el.find('[data-loader]').addClass('d-none');
				// Product loading message on PRODUCT CARD
				el.closest('.js-item-products').find('[js-card-product-message]').addClass('active');
				el.closest('.js-item-products').find('[text-message-warning]').empty().append(response.responseJSON.description);
				// Product loading message on QUICK VIEW
				if (el.hasClass('js-close-quickview')) {
					el.closest('[js-quick-view-product]').find('[js-quickview-message]').addClass('active');
					el.closest('[js-quick-view-product]').find('[text-message-warning]').empty().append(response.responseJSON.description);
				}
			}
		});
	});
	/* Open - Minicart Popup */
	/* -------------------------------------------------------------------------------------- */
	$('[js-open-minicart]').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		addMiniCart();
	});
	/* Close - Minicart Popup */
	/* -------------------------------------------------------------------------------------- */
	$('[js-close-minicart]').on('click', function(event) {
		event.preventDefault();
		/* Act on the event */
		$('.c-cart-pop-mini').removeClass('active');
	});
	/* Add note to cart - Minicart Popup */
	/* -------------------------------------------------------------------------------------- */
	$('[js-minicart-popup]').on('click', '.js-cart-min-add-note', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var note = $('.js-cart-add-note').val();
		updateNoteMiniCart(note);
	});
	/* Remove to cart - Minicart Popup */
	/* -------------------------------------------------------------------------------------- */
	$('[js-minicart-popup]').on('click', '.js-cart-min-remove', async function(event) {
		event.preventDefault();
		event.stopPropagation();
		var el = $(this),
			line_item = parseFloat(el.attr("data-product-line")),
			product_id = parseFloat(el.closest('.js-cart-min-item').attr("data-product-id"));
		el.text('Procesando..');
		updateMiniCart(0,line_item);
	});
	/* Quantity Product - Minicart Popup */
	/* -------------------------------------------------------------------------------------- */
	$('[js-minicart-popup]').on('click', '[name=minus]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var spinner = $(this),
			input = spinner.closest('.js-add-minicart-quantity').find('input[type="number"]'),
			min = input.attr('min'),
			max = input.attr('max'),
			oldValue = parseFloat(input.val()),
			line_item = parseFloat(spinner.closest('.js-cart-min-item').attr("data-product-line")),
			product_id = parseFloat(spinner.closest('.js-cart-min-item').attr("data-product-id"));
		if (oldValue <= min) {
			var newVal = oldValue;
		} else {
			var newVal = oldValue - 1;
		}
		input.val(newVal);
		input.trigger("change");
		updateMiniCart(newVal,line_item);
	});

	$('[js-minicart-popup]').on('click', '[name=plus]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var spinner = $(this),
			input = spinner.closest('.js-add-minicart-quantity').find('input[type="number"]'),
			min = input.attr('min'),
			max = input.attr('max'),
			oldValue = parseFloat(input.val()),
			line_item = parseFloat(spinner.closest('.js-cart-min-item').attr("data-product-line")),
			product_id = parseFloat(spinner.closest('.js-cart-min-item').attr("data-product-id"));
		if (oldValue >= max) {
			var newVal = oldValue;
		} else {
			var newVal = oldValue + 1;
		}
		input.val(newVal);
		input.trigger("change");
		updateMiniCart(newVal,line_item);
	});

	$('[js-minicart-popup]').on('keyup', '.js-quantity-input', debounce(function(){
		var input = $(this),
			inputValue = parseFloat(input.val()),
			line_item = input.attr("data-index"),
			product_id = parseFloat(input.closest('.js-cart-min-item').attr("data-product-id")),
			promoProducts = input.closest('.js-cart-min-item').attr("data-product-promo"),
			actualizar = true;
		updateMiniCart(inputValue,line_item);
	},500));
	/* Show note - Minicart Popup */
	/* -------------------------------------------------------------------------------------- */
	$('[js-minicart-popup]').on('click', '.js-accordion-item-popup', function(event) {
		/* Act on the event */
		var el = $(this);
		el.toggleClass('show-body');
	});
});